import { Flex, Link } from '@chakra-ui/react';
import { useParsedQuery } from 'components/hooks/useParsedQuery';

import { TextBodyLarge, TextBodyMedium } from 'uiToolkitV1/Typography';

export const NETCHEX_MESSAGES_TYPES = {
  NO_MESH_USER: 'NO_MESH_USER',
  API_MESSAGE_TEXT: 'API_MESSAGE_TEXT',
};

const NETCHEX_MESSAGES = {
  NO_MESH_USER: {
    performance:
      'The Performance module has not been enabled for you. Please try again later or contact your admin for support.',
    engagement:
      'The Survey module has not been enabled for you. Please try again later or contact your admin for support.',
  },
};

const NonAuthenticatedNetchexMessage = () => {
  const { messageType, redirectUrl, apiMessageText } = useParsedQuery();

  const isEngagementModuleUrl = redirectUrl?.includes('/engagement/');

  const urlParams = new URLSearchParams();
  urlParams.set('redirectUrl', redirectUrl);

  let link = process.env.PUBLIC_APP_NETCHEX_LOGIN_URL;

  if (redirectUrl) {
    link = `${link}?${urlParams.toString()}`;
  }

  let message = '';
  switch (messageType) {
    case NETCHEX_MESSAGES_TYPES.NO_MESH_USER:
      message = `${NETCHEX_MESSAGES.NO_MESH_USER[isEngagementModuleUrl ? 'engagement' : 'performance']}`;
      break;
    case NETCHEX_MESSAGES_TYPES.API_MESSAGE_TEXT:
      message = apiMessageText;
      break;
    default:
      message = '';
  }

  return (
    <Flex flexDir="column" gap={3} h="70vh" w="100vw" alignItems="center" justifyContent="center">
      <TextBodyMedium>{message}</TextBodyMedium>
      <TextBodyLarge>
        <Link href={link} textDecor="underline">
          Click here to go back to Netchex login page
        </Link>
      </TextBodyLarge>
    </Flex>
  );
};

const NoMobilePageSupportNetchexMessage = () => (
  <Flex flexDir="column" gap={3} h="70vh" w="100vw" padding="36px" alignItems="center" justifyContent="center">
    <TextBodyMedium textAlign="center">
      This page is not supported on mobile, please use the application on desktop to access this page.
    </TextBodyMedium>
  </Flex>
);

const NoHomePageSupportNetchexMessage = () => (
  <Flex flexDir="column" gap={3} h="70vh" w="100vw" padding="36px" alignItems="center" justifyContent="center">
    <TextBodyMedium textAlign="center" bold>
      This page isn’t available.
    </TextBodyMedium>
    <TextBodyMedium textAlign="center">
      The link may have expired or is no longer valid. Please navigate to a different page.
    </TextBodyMedium>
  </Flex>
);

export { NonAuthenticatedNetchexMessage, NoMobilePageSupportNetchexMessage, NoHomePageSupportNetchexMessage };
